import { useLayoutEffect } from 'react'
import { useNavigationContext } from '../contexts/NavigationContext.jsx'

export const useRetractSidebar = () => {
  const { setSidebarRetracted, sectionIndex } = useNavigationContext()

  useLayoutEffect(() => {
    setSidebarRetracted(true)
    return () => {
      if (sectionIndex) {
        setSidebarRetracted(false)
      }
    }
  }, [])
}
export default useRetractSidebar
